<template>
<v-alert dense text dismissible icon="offline_bolt" type="warning" v-if="duplicate">
    {{duplicate.firstName}} {{duplicate.lastName}} ({{duplicate.email}}) already exists. Only proceed if you are sure this is not a duplicate.
</v-alert>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers'

export default {
    data() {
        return {
            duplicate: false
        }
    },

    components: {
        
    },
    
    props: {
        contact: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        async check() {
            console.log('Checking duplicates...')
            const firstName = this.contact.firstName
            const lastName = this.contact.lastName
            if(!firstName || !lastName) {
                this.duplicate = false
                return
            }
            const duplicate = await ContactHelpers.checkForDuplicates(firstName, lastName)
            if(duplicate)
                this.duplicate = duplicate

            else
                this.duplicate = false
        },
        clearIfEmpty(name) {
            if(!name) {
                this.duplicate = false
            }
        }
    },

    created() {

    },

    watch: {
        'contact.firstName': {
            handler: function(newVal) {
                this.clearIfEmpty(newVal)
            }
        },
        'contact.lastName': {
            handler: function(newVal) {
                this.clearIfEmpty(newVal)
            }
        }
 
    }


}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// UniqueContactEnforcer.vue?76643617